import { useState } from 'react';
import { useMotionValueEvent } from 'framer-motion';

// Turns a continuous 0-1 scroll-progress MotionValue into a boolean that
// flips the instant `progress` crosses `threshold`, in either direction
// (scrolling back up un-flips it). Consumers animate the flip themselves
// with their own fixed-duration transition — this hook only decides *when*.
export const useScrollStage = (progress, threshold) => {
  const [active, setActive] = useState(() => progress.get() >= threshold);
  useMotionValueEvent(progress, 'change', (latest) => setActive(latest >= threshold));
  return active;
};
